import { createSlice } from "@reduxjs/toolkit";
import { defaultApiState } from "../../../common/constants/api-constants";
import { ActionStatus } from "../../../common/constants/action-status";
import { InclusiveAccessState } from "../interface/inclusive-access.interface";
import { fetchInclusiveAccessData } from "../thunks/fetch-inclusive-access.thunk";
import { updateInclusiveAccessData } from "../thunks/update-inclusive-access.thunk";

export const inclusiveAccessInitialState: InclusiveAccessState = defaultApiState;

/*----- CREATE STORE SLICE ------*/

export const inclusiveAccessSlice = createSlice({
    name: "orderHistory",
    initialState: inclusiveAccessInitialState,
    reducers:{},
    extraReducers(builder){
      builder
      .addCase(fetchInclusiveAccessData.pending, (state) =>{
        state.status = ActionStatus.loading;
      })
      .addCase(fetchInclusiveAccessData.fulfilled, (state, action) =>{
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchInclusiveAccessData.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
      .addCase(updateInclusiveAccessData.pending, (state) =>{
        state.status = ActionStatus.loading;
      })
      .addCase(updateInclusiveAccessData.fulfilled, (state, action) =>{
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(updateInclusiveAccessData.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
    }
  });

/*----- CREATE REDUCER ------*/

export const inclusiveAccessReducer = inclusiveAccessSlice.reducer;